import { render, staticRenderFns } from "./replaceHost.vue?vue&type=template&id=2edd0d4b&"
import script from "./replaceHost.vue?vue&type=script&lang=js&"
export * from "./replaceHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports